{
  "/1/korea/": {
    "country_ja": "韓国",
    "country": "korea",
    "cc": "kr",
    "lat": 35.907757,
    "lon": 127.766922,
    "td_city_list": "ソウル、仁川、チェジュ島"
  },
  "/1/north-korea/": {
    "country_ja": "北朝鮮",
    "country": "north-korea",
    "cc": "kp",
    "lat": 40.339852,
    "lon": 127.510093,
    "td_city_list": "平壌"
  },
  "/1/taiwan/": {
    "country_ja": "台湾",
    "country": "taiwan",
    "cc": "tw",
    "lat": 23.69781,
    "lon": 120.960515,
    "td_city_list": "台中、台北"
  },
  "/1/china/": {
    "country_ja": "中国",
    "country": "china",
    "cc": "cn",
    "lat": 35.86166,
    "lon": 104.195397,
    "td_city_list": "上海、北京、青島、大連、重慶"
  },
  "/1/hong-kong/": {
    "country_ja": "香港",
    "country": "hong-kong",
    "cc": "hk",
    "lat": 22.3193039,
    "lon": 114.1693611,
    "td_city_list": "香港、ディズニーランド"
  },
  "/1/macau/": {
    "country_ja": "マカオ",
    "country": "macau",
    "cc": "mo",
    "lat": 22.198745,
    "lon": 113.543873,
    "td_city_list": "マカオ"
  },
  "/1/mongolia/": {
    "country_ja": "モンゴル",
    "country": "mongolia",
    "cc": "mn",
    "lat": 46.862496,
    "lon": 103.846656,
    "td_city_list": "ウランバートル、アルタイ"
  },
  "/2/indonesia/": {
    "country_ja": "インドネシア",
    "country": "indonesia",
    "cc": "id",
    "lat": -0.789275,
    "lon": 113.921327,
    "td_city_list": "ジャカルタ、ジョグジャカルタ、バンドン"
  },
  "/2/cambodia/": {
    "country_ja": "カンボジア",
    "country": "cambodia",
    "cc": "kh",
    "lat": 12.565679,
    "lon": 104.990963,
    "td_city_list": "プノンペン、シェムリアップ"
  },
  "/2/singapore/": {
    "country_ja": "シンガポール",
    "country": "singapore",
    "cc": "sg",
    "lat": 1.352083,
    "lon": 103.819836,
    "td_city_list": "シンガポール"
  },
  "/2/thailand/": {
    "country_ja": "タイ",
    "country": "thailand",
    "cc": "th",
    "lat": 15.870032,
    "lon": 100.992541,
    "td_city_list": "バンコク、プーケット、チェンマイ"
  },
  "/2/philippines/": {
    "country_ja": "フィリピン",
    "country": "philippines",
    "cc": "ph",
    "lat": 12.879721,
    "lon": 121.774017,
    "td_city_list": "マニラ、セブ"
  },
  "/2/brunei/": {
    "country_ja": "ブルネイ",
    "country": "brunei",
    "cc": "bn",
    "lat": 4.535277,
    "lon": 114.727669,
    "td_city_list": "バンダルスリブガワン"
  },
  "/2/vietnam/": {
    "country_ja": "ベトナム",
    "country": "vietnam",
    "cc": "vn",
    "lat": 14.058324,
    "lon": 108.277199,
    "td_city_list": "ハノイ、ダナン、ホーチミン"
  },
  "/2/malaysia/": {
    "country_ja": "マレーシア",
    "country": "malaysia",
    "cc": "my",
    "lat": 4.210484,
    "lon": 101.975766,
    "td_city_list": "クアラルンプール、ジョホールバル"
  },
  "/2/myanmar/": {
    "country_ja": "ミャンマー",
    "country": "myanmar",
    "cc": "mm",
    "lat": 21.916221,
    "lon": 95.955974,
    "td_city_list": "マンダレー、ヤンゴン"
  },
  "/2/laos/": {
    "country_ja": "ラオス人民民主共和国",
    "country": "laos",
    "cc": "la",
    "lat": 19.85627,
    "lon": 102.495496,
    "td_city_list": "ヴィエンチャン"
  },
  "/3/india/": {
    "country_ja": "インド",
    "country": "india",
    "cc": "in",
    "lat": 20.593684,
    "lon": 78.96288,
    "td_city_list": "バンガロール、ムンバイ、ニューデリー"
  },
  "/3/sri-lanka/": {
    "country_ja": "スリランカ",
    "country": "sri-lanka",
    "cc": "lk",
    "lat": 7.873054,
    "lon": 80.771797,
    "td_city_list": "コロンボ、キャンディ"
  },
  "/3/nepal/": {
    "country_ja": "ネパール",
    "country": "nepal",
    "cc": "np",
    "lat": 28.394857,
    "lon": 84.124008,
    "td_city_list": "カトマンズ"
  },
  "/3/pakistan/": {
    "country_ja": "パキスタン",
    "country": "pakistan",
    "cc": "pk",
    "lat": 30.375321,
    "lon": 69.345116,
    "td_city_list": "イスラマバード、カラチ"
  },
  "/3/bangladesh/": {
    "country_ja": "バングラデシュ",
    "country": "bangladesh",
    "cc": "bd",
    "lat": 23.684994,
    "lon": 90.356331,
    "td_city_list": "ダッカ、チッタゴン"
  },
  "/3/bhutan/": {
    "country_ja": "ブータン王国",
    "country": "bhutan",
    "cc": "bt",
    "lat": 27.514162,
    "lon": 90.433601,
    "td_city_list": "ティンプー"
  },
  "/3/maldives/": {
    "country_ja": "モルディブ",
    "country": "maldives",
    "cc": "mv",
    "lat": 3.202778,
    "lon": 73.22068,
    "td_city_list": "アッドゥ環礁、マレ"
  },
  "/5/azerbaijan/": {
    "country_ja": "アゼルバイジャン",
    "country": "azerbaijan",
    "cc": "az",
    "lat": 40.143105,
    "lon": 47.576927,
    "td_city_list": "バクー"
  },
  "/4/afghanistan/": {
    "country_ja": "アフガニスタン",
    "country": "afghanistan",
    "cc": "af",
    "lat": 33.93911,
    "lon": 67.709953,
    "td_city_list": "カブール"
  },
  "/4/uae/": {
    "country_ja": "アラブ首長国連邦",
    "country": "uae",
    "cc": "ae",
    "lat": 23.424076,
    "lon": 53.847818,
    "td_city_list": "ドバイ、アブダビ"
  },
  "/4/yemen/": {
    "country_ja": "イエメン",
    "country": "yemen",
    "cc": "ye",
    "lat": 15.552727,
    "lon": 48.516388,
    "td_city_list": "サヌア"
  },
  "/4/israel/": {
    "country_ja": "イスラエル",
    "country": "israel",
    "cc": "il",
    "lat": 31.046051,
    "lon": 34.851612,
    "td_city_list": "エルサレム、ハイファ"
  },
  "/4/iraq/": {
    "country_ja": "イラク",
    "country": "iraq",
    "cc": "iq",
    "lat": 33.223191,
    "lon": 43.679291,
    "td_city_list": "バグダッド"
  },
  "/4/iran/": {
    "country_ja": "イラン",
    "country": "iran",
    "cc": "ir",
    "lat": 32.427908,
    "lon": 53.688046,
    "td_city_list": "テヘラン、シラーズ、エスファハーン"
  },
  "/4/uzbekistan/": {
    "country_ja": "ウズベキスタン",
    "country": "uzbekistan",
    "cc": "uz",
    "lat": 41.377491,
    "lon": 64.585262,
    "td_city_list": "サマルカンド、タシケント"
  },
  "/4/oman/": {
    "country_ja": "オマーン",
    "country": "oman",
    "cc": "om",
    "lat": 21.4735329,
    "lon": 55.975413,
    "td_city_list": "サラーラ、マスカット"
  },
  "/4/kazakhstan/": {
    "country_ja": "カザフスタン",
    "country": "kazakhstan",
    "cc": "kz",
    "lat": 48.019573,
    "lon": 66.923684,
    "td_city_list": "アスタナ、アルマティ、テュルキスタン"
  },
  "/4/qatar/": {
    "country_ja": "カタール",
    "country": "qatar",
    "cc": "qa",
    "lat": 25.354826,
    "lon": 51.183884,
    "td_city_list": "ドーハ"
  },
  "/4/cyprus/": {
    "country_ja": "キプロス",
    "country": "cyprus",
    "cc": "cy",
    "lat": 35.126413,
    "lon": 33.429859,
    "td_city_list": "ラルナカ"
  },
  "/4/kyrgyzstan/": {
    "country_ja": "キルギス",
    "country": "kyrgyzstan",
    "cc": "kg",
    "lat": 41.20438,
    "lon": 74.766098,
    "td_city_list": "ナルイン"
  },
  "/4/kuwait/": {
    "country_ja": "クウェート",
    "country": "kuwait",
    "cc": "kw",
    "lat": 29.31166,
    "lon": 47.481766,
    "td_city_list": "クウェート"
  },
  "/4/saudi-arabia/": {
    "country_ja": "サウジアラビア",
    "country": "saudi-arabia",
    "cc": "sa",
    "lat": 23.885942,
    "lon": 45.079162,
    "td_city_list": "メッカ、リヤド、ジッダ"
  },
  "/4/syria/": {
    "country_ja": "シリア",
    "country": "syria",
    "cc": "sy",
    "lat": 34.802075,
    "lon": 38.996815,
    "td_city_list": "アレッポ、ダマスカス、パルミラ"
  },
  "/5/georgia/": {
    "country_ja": "ジョージア",
    "country": "georgia",
    "cc": "ge",
    "lat": 42.315407,
    "lon": 43.356892,
    "td_city_list": "トビリシ"
  },
  "/4/tajikistan/": {
    "country_ja": "タジキスタン",
    "country": "tajikistan",
    "cc": "tj",
    "lat": 38.861034,
    "lon": 71.276093,
    "td_city_list": "ドゥシャンベ"
  },
  "/4/turkmenistan/": {
    "country_ja": "トルクメニスタン",
    "country": "turkmenistan",
    "cc": "tm",
    "lat": 38.969719,
    "lon": 59.556278,
    "td_city_list": "アシガバット、トルクメンバシ"
  },
  "/4/turkiye/": {
    "country_ja": "トルコ",
    "country": "turkiye",
    "cc": "tr",
    "lat": 38.963745,
    "lon": 35.243322,
    "td_city_list": "イスタンブール、アンカラ、アンタルヤ、イズミル"
  },
  "/4/bahrain/": {
    "country_ja": "バーレーン",
    "country": "bahrain",
    "cc": "bh",
    "lat": 26.0667,
    "lon": 50.5577,
    "td_city_list": "マナーマ"
  },
  "/4/jordan/": {
    "country_ja": "ヨルダン",
    "country": "jordan",
    "cc": "jo",
    "lat": 30.585164,
    "lon": 36.238414,
    "td_city_list": "マアーン"
  },
  "/4/lebanon/": {
    "country_ja": "レバノン",
    "country": "lebanon",
    "cc": "lb",
    "lat": 33.854721,
    "lon": 35.862285,
    "td_city_list": "トリポリ、ベイルート"
  },
  "/5/iceland/": {
    "country_ja": "アイスランド",
    "country": "iceland",
    "cc": "is",
    "lat": 64.963051,
    "lon": -19.020835,
    "td_city_list": "アクレイリ、レイキャビク"
  },
  "/5/ireland/": {
    "country_ja": "アイルランド",
    "country": "ireland",
    "cc": "ie",
    "lat": 53.7797554,
    "lon": -7.3055309,
    "td_city_list": "コルク、ダブリン、ロスレア"
  },
  "/5/albania/": {
    "country_ja": "アルバニア",
    "country": "albania",
    "cc": "al",
    "lat": 41.153332,
    "lon": 20.168331,
    "td_city_list": "ティラナ"
  },
  "/5/uk/": {
    "country_ja": "イギリス",
    "country": "uk",
    "cc": "gb",
    "lat": 52.3555177,
    "lon": -1.1743197,
    "td_city_list": "ロンドン、リバプール、マンチェスター"
  },
  "/5/italy/": {
    "country_ja": "イタリア",
    "country": "italy",
    "cc": "it",
    "lat": 41.87194,
    "lon": 12.56738,
    "td_city_list": "ローマヴェネツィア、ミラノ、フィレンツェ"
  },
  "/5/ukraine/": {
    "country_ja": "ウクライナ",
    "country": "ukraine",
    "cc": "ua",
    "lat": 48.379433,
    "lon": 31.16558,
    "td_city_list": "オデーサ、キーウ"
  },
  "/5/estonia/": {
    "country_ja": "エストニア",
    "country": "estonia",
    "cc": "ee",
    "lat": 58.595272,
    "lon": 25.013607,
    "td_city_list": "タリン"
  },
  "/5/netherlands/": {
    "country_ja": "オランダ",
    "country": "netherlands",
    "cc": "nl",
    "lat": 52.132633,
    "lon": 5.291266,
    "td_city_list": "アムステルダム、マーストリヒト、ユトレヒト"
  },
  "/5/austria/": {
    "country_ja": "オーストリア",
    "country": "austria",
    "cc": "at",
    "lat": 47.516231,
    "lon": 14.550072,
    "td_city_list": "ウィーン、リンツ、ザルツブルク"
  },
  "/5/north-macedonia/": {
    "country_ja": "北マケドニア",
    "country": "north-macedonia",
    "cc": "mk",
    "lat": 41.608635,
    "lon": 21.745275,
    "td_city_list": "スコピエ"
  },
  "/5/greece/": {
    "country_ja": "ギリシャ",
    "country": "greece",
    "cc": "gr",
    "lat": 39.074208,
    "lon": 21.824312,
    "td_city_list": "アテネ、イラクリオン（クレタ島）"
  },
  "/5/croatia/": {
    "country_ja": "クロアチア",
    "country": "croatia",
    "cc": "hr",
    "lat": 45.1,
    "lon": 15.2,
    "td_city_list": "ザグレブ"
  },
  "/5/gibraltar/": {
    "country_ja": "ジブラルタル",
    "country": "gibraltar",
    "cc": "gi",
    "lat": 36.140751,
    "lon": -5.353585,
    "td_city_list": "ジブラルタル"
  },
  "/5/switzerland/": {
    "country_ja": "スイス",
    "country": "switzerland",
    "cc": "ch",
    "lat": 46.818188,
    "lon": 8.227512,
    "td_city_list": "ジュネーブ、ベルン、インターラーケン"
  },
  "/5/sweden/": {
    "country_ja": "スウェーデン",
    "country": "sweden",
    "cc": "se",
    "lat": 60.128161,
    "lon": 18.643501,
    "td_city_list": "ストックホルム、エステルスンド"
  },
  "/5/spain/": {
    "country_ja": "スペイン",
    "country": "spain",
    "cc": "es",
    "lat": 40.463667,
    "lon": -3.74922,
    "td_city_list": "バルセロナ、バレンシア、マドリード、マヨルカ島"
  },
  "/5/slovakia/": {
    "country_ja": "スロバキア",
    "country": "slovakia",
    "cc": "sk",
    "lat": 48.669026,
    "lon": 19.699024,
    "td_city_list": "コシツェ、ブラティスラバ"
  },
  "/5/serbia/": {
    "country_ja": "セルビア",
    "country": "serbia",
    "cc": "rs",
    "lat": 44.016521,
    "lon": 21.005859,
    "td_city_list": "クラリエボ、ニシュ"
  },
  "/5/czech/": {
    "country_ja": "チェコ",
    "country": "czech",
    "cc": "cz",
    "lat": 49.817492,
    "lon": 15.472962,
    "td_city_list": "プラハ、オストラバ"
  },
  "/5/denmark/": {
    "country_ja": "デンマーク",
    "country": "denmark",
    "cc": "dk",
    "lat": 56.26392,
    "lon": 9.501785,
    "td_city_list": "コペンハーゲン、ヌーク"
  },
  "/5/germany/": {
    "country_ja": "ドイツ",
    "country": "germany",
    "cc": "de",
    "lat": 51.165691,
    "lon": 10.451526,
    "td_city_list": "ベルリン、ディッセルドルフ、フランクフルト、ミュンヘン"
  },
  "/5/norway/": {
    "country_ja": "ノルウェー",
    "country": "norway",
    "cc": "no",
    "lat": 60.472024,
    "lon": 8.468946,
    "td_city_list": "オスロ、アルタ、トロムソ"
  },
  "/5/belarus/": {
    "country_ja": "ベラルーシ",
    "country": "belarus",
    "cc": "by",
    "lat": 53.709807,
    "lon": 27.953389,
    "td_city_list": "ブレスト、ホメリ、ミンスク"
  },
  "/5/belgium/": {
    "country_ja": "ベルギー",
    "country": "belgium",
    "cc": "be",
    "lat": 50.503887,
    "lon": 4.469936,
    "td_city_list": "アントウェルペン、ブリュッセル"
  },
  "/5/bosnia-and-herzegovina/": {
    "country_ja": "ボスニア・ヘルツェゴビナ",
    "country": "bosnia-and-herzegovina",
    "cc": "ba",
    "lat": 43.915886,
    "lon": 17.679076,
    "td_city_list": "サラエボ"
  },
  "/5/portugal/": {
    "country_ja": "ポルトガル",
    "country": "portugal",
    "cc": "pt",
    "lat": 39.399872,
    "lon": -8.224454,
    "td_city_list": "リスボン、ポルト、フンシャル、マデイラ諸島"
  },
  "/5/poland/": {
    "country_ja": "ポーランド",
    "country": "poland",
    "cc": "pl",
    "lat": 51.919438,
    "lon": 19.145136,
    "td_city_list": "ワルシャワ、グダニスク"
  },
  "/5/malta/": {
    "country_ja": "マルタ",
    "country": "malta",
    "cc": "mt",
    "lat": 35.937496,
    "lon": 14.375416,
    "td_city_list": "バレッタ"
  },
  "/5/moldova/": {
    "country_ja": "モルドバ",
    "country": "moldova",
    "cc": "md",
    "lat": 47.411631,
    "lon": 28.369885,
    "td_city_list": "キシナウ"
  },
  "/5/montenegro/": {
    "country_ja": "モンテネグロ",
    "country": "montenegro",
    "cc": "me",
    "lat": 42.708678,
    "lon": 19.37439,
    "td_city_list": "プリエプリャ、ポドゴリツァ"
  },
  "/5/latvia/": {
    "country_ja": "ラトビア",
    "country": "latvia",
    "cc": "lv",
    "lat": 56.879635,
    "lon": 24.603189,
    "td_city_list": "リガ、ダウガフピールス、リエパヤ"
  },
  "/5/hungary/": {
    "country_ja": "ハンガリー",
    "country": "hungary",
    "cc": "hu",
    "lat": 47.162494,
    "lon": 19.503304,
    "td_city_list": "ブダペスト、ジェール"
  },
  "/5/finland/": {
    "country_ja": "フィンランド",
    "country": "finland",
    "cc": "fi",
    "lat": 61.92411,
    "lon": 25.748151,
    "td_city_list": "ヘルシンキ、ロバニエミ"
  },
  "/5/france/": {
    "country_ja": "フランス",
    "country": "france",
    "cc": "fr",
    "lat": 46.227638,
    "lon": 2.213749,
    "td_city_list": "パリ、マルセイユ、リヨン、ランス"
  },
  "/5/bulgaria/": {
    "country_ja": "ブルガリア",
    "country": "bulgaria",
    "cc": "bg",
    "lat": 42.733883,
    "lon": 25.48583,
    "td_city_list": "ソフィア、バルナ"
  },
  "/5/lithuania/": {
    "country_ja": "リトアニア",
    "country": "lithuania",
    "cc": "lt",
    "lat": 55.169438,
    "lon": 23.881275,
    "td_city_list": "ビリニュス、カウナス、クライペダ"
  },
  "/5/liechtenstein/": {
    "country_ja": "リヒテンシュタイン",
    "country": "liechtenstein",
    "cc": "li",
    "lat": 47.1410392,
    "lon": 9.520935,
    "td_city_list": "ファドゥーツ"
  },
  "/5/luxembourg/": {
    "country_ja": "ルクセンブルク",
    "country": "luxembourg",
    "cc": "lu",
    "lat": 49.815273,
    "lon": 6.129583,
    "td_city_list": "ルクセンブルク"
  },
  "/5/romania/": {
    "country_ja": "ルーマニア",
    "country": "romania",
    "cc": "ro",
    "lat": 45.943161,
    "lon": 24.96676,
    "td_city_list": "アラド、ブカレスト、コンスタンツァ"
  },
  "/5/russia/": {
    "country_ja": "ロシア",
    "country": "russia",
    "cc": "ru",
    "lat": 61.52401,
    "lon": 105.318756,
    "td_city_list": "モスクワ、ウラジオストク、ヤクーツク"
  },
  "/5/kosovo/": {
    "country_ja": "コソボ",
    "country": "kosovo",
    "cc": "xk",
    "lat": 42.6026359,
    "lon": 20.902977,
    "td_city_list": "プリシュティナ"
  },
  "/5/san-marino/": {
    "country_ja": "サンマリノ共和国",
    "country": "san-marino",
    "cc": "sm",
    "lat": 43.94236,
    "lon": 12.457777,
    "td_city_list": "サンマリノ"
  },
  "/5/slovenia/": {
    "country_ja": "スロベニア共和国",
    "country": "slovenia",
    "cc": "si",
    "lat": 46.151241,
    "lon": 14.995463,
    "td_city_list": "リュブリャナ、マリボル"
  },
  "/5/vatican-city/": {
    "country_ja": "バチカン市国",
    "country": "vatican-city",
    "cc": "va",
    "lat": 41.902916,
    "lon": 12.453389,
    "td_city_list": "バチカン市国"
  },
  "/5/monaco/": {
    "country_ja": "モナコ公国",
    "country": "monaco",
    "cc": "mc",
    "lat": 43.7384176,
    "lon": 7.4246158,
    "td_city_list": "モナコ"
  },
  "/6/hawaii/": {
    "country_ja": "ハワイ",
    "country": "hawaii",
    "cc": "us",
    "lat": 19.8986819,
    "lon": -155.6658568,
    "td_city_list": "ホノルル（オアフ島）、ヒロ（ハワイ島）"
  },
  "/6/australia/": {
    "country_ja": "オーストラリア",
    "country": "australia",
    "cc": "au",
    "lat": -25.274398,
    "lon": 133.775136,
    "td_city_list": "メルボルン、シドニー、パース、ケアンズ"
  },
  "/6/new-zealand/": {
    "country_ja": "ニュージーランド",
    "country": "new-zealand",
    "cc": "nz",
    "lat": -40.900557,
    "lon": 174.885971,
    "td_city_list": "オークランド、ネルソン、クライストチャーチ"
  },
  "/6/guam/": {
    "country_ja": "グアム",
    "country": "guam",
    "cc": "gu",
    "lat": 13.3823791,
    "lon": 144.6972774,
    "td_city_list": "タモン（グアム島）"
  },
  "/6/saipan/": {
    "country_ja": "サイパン",
    "country": "saipan",
    "cc": "mp",
    "lat": 15.1850483,
    "lon": 145.7467259,
    "td_city_list": "サイパン島"
  },
  "/6/tahiti/": {
    "country_ja": "タヒチ",
    "country": "tahiti",
    "cc": "pf",
    "lat": -17.6509195,
    "lon": -149.4260421,
    "td_city_list": "パペーテ（タヒチ島）"
  },
  "/6/american-samoa/": {
    "country_ja": "アメリカ領サモア",
    "country": "american-samoa",
    "cc": "as",
    "lat": -14.270972,
    "lon": -170.132217,
    "td_city_list": "パゴパゴ"
  },
  "/6/kiribati/": {
    "country_ja": "キリバス",
    "country": "kiribati",
    "cc": "ki",
    "lat": 1.44213,
    "lon": 172.9829763,
    "td_city_list": "バイリキ（タラワ島）"
  },
  "/6/cook-islands/": {
    "country_ja": "クック諸島",
    "country": "cook-islands",
    "cc": "ck",
    "lat": -21.236736,
    "lon": -159.777671,
    "td_city_list": "アバルア（ラロトンガ島）"
  },
  "/6/independent-state-of-samoa/": {
    "country_ja": "サモア独立国",
    "country": "independent-state-of-samoa",
    "cc": "ws",
    "lat": -13.759029,
    "lon": -172.104629,
    "td_city_list": "アピア"
  },
  "/6/solomon-islands/": {
    "country_ja": "ソロモン諸島",
    "country": "solomon-islands",
    "cc": "sb",
    "lat": -9.64571,
    "lon": 160.156194,
    "td_city_list": "ホニアラ"
  },
  "/6/tuvalu/": {
    "country_ja": "ツバル",
    "country": "tuvalu",
    "cc": "tv",
    "lat": -7.109535,
    "lon": 177.64933,
    "td_city_list": "フナフティ"
  },
  "/6/tonga/": {
    "country_ja": "トンガ",
    "country": "tonga",
    "cc": "to",
    "lat": -21.178986,
    "lon": -175.198242,
    "td_city_list": "ヌクアロファ（トンガタプ諸島）"
  },
  "/6/new-caledonia/": {
    "country_ja": "ニューカレドニア",
    "country": "new-caledonia",
    "cc": "nc",
    "lat": -20.904305,
    "lon": 165.618042,
    "td_city_list": "ヌメア"
  },
  "/6/vanuatu/": {
    "country_ja": "バヌアツ",
    "country": "vanuatu",
    "cc": "vu",
    "lat": -15.376706,
    "lon": 166.959158,
    "td_city_list": "ポートビラ（エファテ島）"
  },
  "/6/papua-new-guinea/": {
    "country_ja": "パプアニューギニア",
    "country": "papua-new-guinea",
    "cc": "pg",
    "lat": -6.314993,
    "lon": 143.95555,
    "td_city_list": "マダン"
  },
  "/6/palau/": {
    "country_ja": "パラオ",
    "country": "palau",
    "cc": "pw",
    "lat": 7.51498,
    "lon": 134.58252,
    "td_city_list": "コロール"
  },
  "/6/fiji/": {
    "country_ja": "フィジー",
    "country": "fiji",
    "cc": "fj",
    "lat": -17.713371,
    "lon": 178.065032,
    "td_city_list": "ナンディ"
  },
  "/6/marshall-islands/": {
    "country_ja": "マーシャル諸島",
    "country": "marshall-islands",
    "cc": "mh",
    "lat": 7.131474,
    "lon": 171.184478,
    "td_city_list": "マジュロ"
  },
  "/6/micronesia/": {
    "country_ja": "ミクロネシア連邦",
    "country": "micronesia",
    "cc": "fm",
    "lat": 7.425554,
    "lon": 150.550812,
    "td_city_list": "ヌクオロ島"
  },
  "/6/wallis-and-futuna/": {
    "country_ja": "ワリス・フテュナ",
    "country": "wallis-and-futuna",
    "cc": "wf",
    "lat": -14.2938,
    "lon": -178.1165,
    "td_city_list": "フテュナ島"
  },
  "/6/nauru/": {
    "country_ja": "ナウル共和国",
    "country": "nauru",
    "cc": "nr",
    "lat": -0.522778,
    "lon": 166.931503,
    "td_city_list": "ヤレン地区"
  },
  "/6/niue/": {
    "country_ja": "ニウエ",
    "country": "niue",
    "cc": "nu",
    "lat": -19.054445,
    "lon": -169.867233,
    "td_city_list": "アロフィ"
  },
  "/2/east-timor/": {
    "country_ja": "東ティモール民主共和国",
    "country": "east-timor",
    "cc": "tl",
    "lat": -8.874217,
    "lon": 125.727539,
    "td_city_list": "ディリ"
  },
  "/7/us/": {
    "country_ja": "アメリカ",
    "country": "us",
    "cc": "us",
    "lat": 38.7945952,
    "lon": -106.5348379,
    "td_city_list": "ニューヨーク、ロサンゼルス、サンフランシスコ、デトロイト"
  },
  "/7/alaska/": {
    "country_ja": "アラスカ",
    "country": "alaska",
    "cc": "us",
    "lat": 63.588753,
    "lon": -154.4930619,
    "td_city_list": "バロー、ノーム、フェアバンクス、アンカレジ"
  },
  "/7/canada/": {
    "country_ja": "カナダ",
    "country": "canada",
    "cc": "ca",
    "lat": 56.130366,
    "lon": -106.346771,
    "td_city_list": "トロント、バンクーバー、ビクトリア、モントリオール"
  },
  "/7/bermuda/": {
    "country_ja": "バーミューダ諸島",
    "country": "bermuda",
    "cc": "bm",
    "lat": 32.3078,
    "lon": -64.7505,
    "td_city_list": "ハミルトン"
  },
  "/8/mexico/": {
    "country_ja": "メキシコ",
    "country": "mexico",
    "cc": "mx",
    "lat": 23.634501,
    "lon": -102.552784,
    "td_city_list": "アカプルコ、カンクン、ラパス"
  },
  "/8/us-virgin-islands/": {
    "country_ja": "アメリカ領バージン諸島",
    "country": "us-virgin-islands",
    "cc": "vi",
    "lat": 18.335765,
    "lon": -64.896335,
    "td_city_list": "シャーロット、アマリエ"
  },
  "/8/argentina/": {
    "country_ja": "アルゼンチン",
    "country": "argentina",
    "cc": "ar",
    "lat": -38.416097,
    "lon": -63.616672,
    "td_city_list": "ブエノスアイレス、コルドバ、イグアス"
  },
  "/8/uruguay/": {
    "country_ja": "ウルグアイ",
    "country": "uruguay",
    "cc": "uy",
    "lat": -32.522779,
    "lon": -55.765835,
    "td_city_list": "モンテビデオ"
  },
  "/8/ecuador/": {
    "country_ja": "エクアドル",
    "country": "ecuador",
    "cc": "ec",
    "lat": -1.831239,
    "lon": -78.183406,
    "td_city_list": "キト"
  },
  "/8/el-salvador/": {
    "country_ja": "エルサルバドル",
    "country": "el-salvador",
    "cc": "sv",
    "lat": 13.794185,
    "lon": -88.89653,
    "td_city_list": "サンサルバドル"
  },
  "/8/guyana/": {
    "country_ja": "ガイアナ",
    "country": "guyana",
    "cc": "gy",
    "lat": 4.860416,
    "lon": -58.93018,
    "td_city_list": "ジョージタウン"
  },
  "/8/cuba/": {
    "country_ja": "キューバ",
    "country": "cuba",
    "cc": "cu",
    "lat": 21.521757,
    "lon": -77.781167,
    "td_city_list": "ハバナ、マタンサス、サンクティスピリトゥス"
  },
  "/8/guatemala/": {
    "country_ja": "グアテマラ",
    "country": "guatemala",
    "cc": "gt",
    "lat": 15.783471,
    "lon": -90.230759,
    "td_city_list": "フローレス"
  },
  "/8/guadeloupe/": {
    "country_ja": "グアドループ",
    "country": "guadeloupe",
    "cc": "gp",
    "lat": 16.265,
    "lon": -61.551,
    "td_city_list": "ポアント・ア・ピトル"
  },
  "/8/cayman-islands/": {
    "country_ja": "ケイマン諸島",
    "country": "cayman-islands",
    "cc": "ky",
    "lat": 19.3133,
    "lon": -81.2546,
    "td_city_list": "ジョージ・タウン（グランド・ケイマン島）"
  },
  "/8/costa-rica/": {
    "country_ja": "コスタリカ",
    "country": "costa-rica",
    "cc": "cr",
    "lat": 9.748917,
    "lon": -83.753428,
    "td_city_list": "サンホセ"
  },
  "/8/columbia/": {
    "country_ja": "コロンビア",
    "country": "columbia",
    "cc": "co",
    "lat": 4.661232,
    "lon": -74.096235,
    "td_city_list": "ボゴタ、カルタヘナ、バランキージャ"
  },
  "/8/jamaica/": {
    "country_ja": "ジャマイカ",
    "country": "jamaica",
    "cc": "jm",
    "lat": 18.109581,
    "lon": -77.297508,
    "td_city_list": "キングストン、モンテゴベイ"
  },
  "/8/suriname/": {
    "country_ja": "スリナム",
    "country": "suriname",
    "cc": "sr",
    "lat": 3.919305,
    "lon": -56.027783,
    "td_city_list": "パラマリボ"
  },
  "/8/saint-lucia/": {
    "country_ja": "セントルシア",
    "country": "saint-lucia",
    "cc": "lc",
    "lat": 13.909444,
    "lon": -60.978893,
    "td_city_list": "カストリーズ"
  },
  "/8/chile/": {
    "country_ja": "チリ",
    "country": "chile",
    "cc": "cl",
    "lat": -35.675147,
    "lon": -71.542969,
    "td_city_list": "サンティアゴ、アリカ、プンタアレナス"
  },
  "/8/trinidad-and-tobago/": {
    "country_ja": "トリニダード・トバゴ",
    "country": "trinidad-and-tobago",
    "cc": "tt",
    "lat": 10.691803,
    "lon": -61.222503,
    "td_city_list": "ポートオブスペイン"
  },
  "/8/dominican-republic/": {
    "country_ja": "ドミニカ共和国",
    "country": "dominican-republic",
    "cc": "do",
    "lat": 18.735693,
    "lon": -70.162651,
    "td_city_list": "サンティアゴ、サントドミンゴ"
  },
  "/8/bahamas/": {
    "country_ja": "バハマ",
    "country": "bahamas",
    "cc": "bs",
    "lat": 25.03428,
    "lon": -77.39628,
    "td_city_list": "ナッソー"
  },
  "/8/barbados/": {
    "country_ja": "バルバドス",
    "country": "barbados",
    "cc": "bb",
    "lat": 13.193887,
    "lon": -59.543198,
    "td_city_list": "バルバドス島"
  },
  "/8/panama/": {
    "country_ja": "パナマ",
    "country": "panama",
    "cc": "pa",
    "lat": 8.537981,
    "lon": -80.782127,
    "td_city_list": "パナマシティー"
  },
  "/8/paraguay/": {
    "country_ja": "パラグアイ",
    "country": "paraguay",
    "cc": "py",
    "lat": -23.442503,
    "lon": -58.443832,
    "td_city_list": "アスンシオン、コンセプシオン"
  },
  "/8/french-guiana/": {
    "country_ja": "フランス領ギアナ",
    "country": "french-guiana",
    "cc": "gf",
    "lat": 3.933889,
    "lon": -53.125782,
    "td_city_list": "カイエンヌ"
  },
  "/8/brazil/": {
    "country_ja": "ブラジル",
    "country": "brazil",
    "cc": "br",
    "lat": -14.235004,
    "lon": -51.92528,
    "td_city_list": "リオデジャネイロ、サンパウロ、サントス"
  },
  "/8/puerto-rico/": {
    "country_ja": "プエルトリコ",
    "country": "puerto-rico",
    "cc": "pr",
    "lat": 18.220833,
    "lon": -66.590149,
    "td_city_list": "サンファン"
  },
  "/8/venezuela/": {
    "country_ja": "ベネズエラ",
    "country": "venezuela",
    "cc": "ve",
    "lat": 6.42375,
    "lon": -66.58973,
    "td_city_list": "カラカス"
  },
  "/8/belize/": {
    "country_ja": "ベリーズ",
    "country": "belize",
    "cc": "bz",
    "lat": 17.189877,
    "lon": -88.49765,
    "td_city_list": "ベリーズシティ"
  },
  "/8/peru/": {
    "country_ja": "ペルー",
    "country": "peru",
    "cc": "pe",
    "lat": -9.189967,
    "lon": -75.015152,
    "td_city_list": "リマ、クスコ、トルヒーヨ"
  },
  "/8/honduras/": {
    "country_ja": "ホンジュラス",
    "country": "honduras",
    "cc": "hn",
    "lat": 15.199999,
    "lon": -86.241905,
    "td_city_list": "テグシガルパ"
  },
  "/8/bolivia/": {
    "country_ja": "ボリビア",
    "country": "bolivia",
    "cc": "bo",
    "lat": -16.290154,
    "lon": -63.588653,
    "td_city_list": "ラパス、ウユニ、スクレ"
  },
  "/8/martinique/": {
    "country_ja": "マルティニーク",
    "country": "martinique",
    "cc": "mq",
    "lat": 14.641528,
    "lon": -61.024174,
    "td_city_list": "フォール・ド・フランス"
  },
  "/8/antigua-and-barbuda/": {
    "country_ja": "アンティグア・バーブーダ",
    "country": "antigua-and-barbuda",
    "cc": "ag",
    "lat": 17.060816,
    "lon": -61.796428,
    "td_city_list": "セント・ジョンズ"
  },
  "/8/dominica/": {
    "country_ja": "ドミニカ国",
    "country": "dominica",
    "cc": "dm",
    "lat": 15.414999,
    "lon": -61.370976,
    "td_city_list": "ロゾー"
  },
  "/8/saint-kitts-and-nevis/": {
    "country_ja": "セントクリストファー・ネービス",
    "country": "saint-kitts-and-nevis",
    "cc": "kn",
    "lat": 17.357822,
    "lon": -62.782998,
    "td_city_list": "バセテール"
  },
  "/8/grenada/": {
    "country_ja": "グレナダ",
    "country": "grenada",
    "cc": "gd",
    "lat": 12.1165,
    "lon": -61.679,
    "td_city_list": "セント・ジョージズ"
  },
  "/8/saint-vincent-and-the-grenadines/": {
    "country_ja": "セントビンセント及びグレナディーン諸島",
    "country": "saint-vincent-and-the-grenadines",
    "cc": "vc",
    "lat": 12.984305,
    "lon": -61.287228,
    "td_city_list": "キングスタウン"
  },
  "/8/nicaragua/": {
    "country_ja": "ニカラグア共和国",
    "country": "nicaragua",
    "cc": "ni",
    "lat": 12.865416,
    "lon": -85.207229,
    "td_city_list": "グラナダ、マナグア"
  },
  "/8/haiti/": {
    "country_ja": "ハイチ共和国",
    "country": "haiti",
    "cc": "ht",
    "lat": 18.971187,
    "lon": -72.285215,
    "td_city_list": "ポルトー・プランス"
  },
  "/5/armenia/": {
    "country_ja": "アルメニア",
    "country": "armenia",
    "cc": "am",
    "lat": 40.069099,
    "lon": 45.038189,
    "td_city_list": "エレバン"
  },
  "/9/algeria/": {
    "country_ja": "アルジェリア",
    "country": "algeria",
    "cc": "dz",
    "lat": 28.033886,
    "lon": 1.659626,
    "td_city_list": "アルジェ、コンスタンティーヌ、タマンラセト"
  },
  "/9/uganda/": {
    "country_ja": "ウガンダ",
    "country": "uganda",
    "cc": "ug",
    "lat": 1.373333,
    "lon": 32.290275,
    "td_city_list": "アルア、エンテベ"
  },
  "/9/egypt/": {
    "country_ja": "エジプト",
    "country": "egypt",
    "cc": "eg",
    "lat": 26.820553,
    "lon": 30.802498,
    "td_city_list": "カイロ、アレクサンドリア"
  },
  "/9/ethiopia/": {
    "country_ja": "エチオピア",
    "country": "ethiopia",
    "cc": "et",
    "lat": 9.145,
    "lon": 40.489673,
    "td_city_list": "アディスアベバ"
  },
  "/9/cameroon/": {
    "country_ja": "カメルーン",
    "country": "cameroon",
    "cc": "cm",
    "lat": 7.369722,
    "lon": 12.354722,
    "td_city_list": "ンガウンデレ"
  },
  "/9/cape-verde/": {
    "country_ja": "カーボベルデ",
    "country": "cape-verde",
    "cc": "cv",
    "lat": 16.5388,
    "lon": -23.0418,
    "td_city_list": "ミンドロ"
  },
  "/9/gabon/": {
    "country_ja": "ガボン",
    "country": "gabon",
    "cc": "ga",
    "lat": -0.803689,
    "lon": 11.609444,
    "td_city_list": "リーブルビル"
  },
  "/9/gambia/": {
    "country_ja": "ガンビア",
    "country": "gambia",
    "cc": "gm",
    "lat": 13.443182,
    "lon": -15.310139,
    "td_city_list": "バンジュール"
  },
  "/9/guinea/": {
    "country_ja": "ギニア",
    "country": "guinea",
    "cc": "gn",
    "lat": 9.945587,
    "lon": -9.696645,
    "td_city_list": "コナクリ"
  },
  "/9/kenya/": {
    "country_ja": "ケニア",
    "country": "kenya",
    "cc": "ke",
    "lat": -0.023559,
    "lon": 37.906193,
    "td_city_list": "ナイロビ、モンバサ、ナクル"
  },
  "/9/republic-of-the-congo/": {
    "country_ja": "コンゴ共和国",
    "country": "republic-of-the-congo",
    "cc": "cg",
    "lat": -0.228021,
    "lon": 15.827659,
    "td_city_list": "ブラザビル、ポワントノワール"
  },
  "/9/democratic-republic-of-the-congo/": {
    "country_ja": "コンゴ民主共和国",
    "country": "democratic-republic-of-the-congo",
    "cc": "cd",
    "lat": -4.038333,
    "lon": 21.758664,
    "td_city_list": "キンシャサ"
  },
  "/9/ivory-coast/": {
    "country_ja": "コートジボワール",
    "country": "ivory-coast",
    "cc": "ci",
    "lat": 7.539989,
    "lon": -5.54708,
    "td_city_list": "ブアケ"
  },
  "/9/zimbabwe/": {
    "country_ja": "ジンバブエ",
    "country": "zimbabwe",
    "cc": "zw",
    "lat": -19.015438,
    "lon": 29.154857,
    "td_city_list": "ハラレ、ヴィクトリアフォールズ"
  },
  "/9/sudan/": {
    "country_ja": "スーダン",
    "country": "sudan",
    "cc": "sd",
    "lat": 12.862807,
    "lon": 30.217636,
    "td_city_list": "ハルツーム、ポートスーダン"
  },
  "/9/senegal/": {
    "country_ja": "セネガル",
    "country": "senegal",
    "cc": "sn",
    "lat": 14.497401,
    "lon": -14.452362,
    "td_city_list": "カオラック、ダカール"
  },
  "/9/saint-helena-islands/": {
    "country_ja": "セントヘレナ諸島",
    "country": "saint-helena-islands",
    "cc": "sh",
    "lat": -15.9650104,
    "lon": -5.7089241,
    "td_city_list": "セントヘレナ島"
  },
  "/9/seychelles/": {
    "country_ja": "セーシェル",
    "country": "seychelles",
    "cc": "sc",
    "lat": -4.679574,
    "lon": 55.491977,
    "td_city_list": "ビクトリア"
  },
  "/9/tanzania/": {
    "country_ja": "タンザニア",
    "country": "tanzania",
    "cc": "tz",
    "lat": -6.369028,
    "lon": 34.888822,
    "td_city_list": "キリマンジャロ、ダルエスサラーム"
  },
  "/9/chad/": {
    "country_ja": "チャド",
    "country": "chad",
    "cc": "td",
    "lat": 15.454166,
    "lon": 18.732207,
    "td_city_list": "ンジャメナ"
  },
  "/9/central-african-republic/": {
    "country_ja": "中央アフリカ共和国",
    "country": "central-african-republic",
    "cc": "cf",
    "lat": 6.611111,
    "lon": 20.939444,
    "td_city_list": "バンギ"
  },
  "/9/tunisia/": {
    "country_ja": "チュニジア",
    "country": "tunisia",
    "cc": "tn",
    "lat": 33.886917,
    "lon": 9.537499,
    "td_city_list": "チュニス、カイルワン"
  },
  "/9/togo/": {
    "country_ja": "トーゴ",
    "country": "togo",
    "cc": "tg",
    "lat": 8.619543,
    "lon": 0.824782,
    "td_city_list": "ロメ"
  },
  "/9/namibia/": {
    "country_ja": "ナミビア",
    "country": "namibia",
    "cc": "na",
    "lat": -22.95764,
    "lon": 18.49041,
    "td_city_list": "ウィントフック、ウォルビスベイ"
  },
  "/9/niger/": {
    "country_ja": "ニジェール",
    "country": "niger",
    "cc": "ne",
    "lat": 17.607789,
    "lon": 8.081666,
    "td_city_list": "ニアメ、マラディ"
  },
  "/9/burkina-faso/": {
    "country_ja": "ブルキナファソ",
    "country": "burkina-faso",
    "cc": "bf",
    "lat": 12.238333,
    "lon": -1.561593,
    "td_city_list": "ボボ・デューラソ、ワガドゥーグー"
  },
  "/9/benin/": {
    "country_ja": "ベナン",
    "country": "benin",
    "cc": "bj",
    "lat": 9.30769,
    "lon": 2.315834,
    "td_city_list": "コトヌー"
  },
  "/9/botswana/": {
    "country_ja": "ボツワナ",
    "country": "botswana",
    "cc": "bw",
    "lat": -22.328474,
    "lon": 24.684866,
    "td_city_list": "ツアーネ、マウン"
  },
  "/9/madagascar/": {
    "country_ja": "マダガスカル",
    "country": "madagascar",
    "cc": "mg",
    "lat": -18.766947,
    "lon": 46.869107,
    "td_city_list": "アンタナナリボ、フィアナランツォア"
  },
  "/9/mali/": {
    "country_ja": "マリ",
    "country": "mali",
    "cc": "ml",
    "lat": 17.570692,
    "lon": -3.996166,
    "td_city_list": "バマコ、モプティ"
  },
  "/9/south-africa/": {
    "country_ja": "南アフリカ共和国",
    "country": "south-africa",
    "cc": "za",
    "lat": -30.559482,
    "lon": 22.937506,
    "td_city_list": "キンバリー、ケープタウン、プレトリア"
  },
  "/9/south-sudan/": {
    "country_ja": "南スーダン",
    "country": "south-sudan",
    "cc": "ss",
    "lat": 6.8769919,
    "lon": 31.3069788,
    "td_city_list": "ジュバ"
  },
  "/9/mozambique/": {
    "country_ja": "モザンビーク",
    "country": "mozambique",
    "cc": "mz",
    "lat": -18.665695,
    "lon": 35.529562,
    "td_city_list": "マプト"
  },
  "/9/morocco/": {
    "country_ja": "モロッコ",
    "country": "morocco",
    "cc": "ma",
    "lat": 31.791702,
    "lon": -7.09262,
    "td_city_list": "カサブランカ、マラケシュ"
  },
  "/9/mauritania/": {
    "country_ja": "モーリタニア",
    "country": "mauritania",
    "cc": "mr",
    "lat": 21.00789,
    "lon": -10.940835,
    "td_city_list": "ヌアクショット、ティジクジャ"
  },
  "/9/libya/": {
    "country_ja": "リビア",
    "country": "libya",
    "cc": "ly",
    "lat": 26.3351,
    "lon": 17.228331,
    "td_city_list": "アウーバーリー、トリポリ"
  },
  "/9/angola/": {
    "country_ja": "アンゴラ",
    "country": "angola",
    "cc": "ao",
    "lat": -11.202692,
    "lon": 17.873887,
    "td_city_list": "ルアンダ"
  },
  "/9/eswatini/": {
    "country_ja": "エスワティニ王国",
    "country": "eswatini",
    "cc": "sz",
    "lat": -26.522503,
    "lon": 31.465866,
    "td_city_list": "ムババネ、ロバンバ"
  },
  "/9/eritrea/": {
    "country_ja": "エリトリア国",
    "country": "eritrea",
    "cc": "er",
    "lat": 15.179384,
    "lon": 39.782334,
    "td_city_list": "アスマラ"
  },
  "/9/guinea-bissau/": {
    "country_ja": "ギニアビサウ共和国",
    "country": "guinea-bissau",
    "cc": "gw",
    "lat": 11.803749,
    "lon": -15.180413,
    "td_city_list": "ビサウ"
  },
  "/9/ghana/": {
    "country_ja": "ガーナ共和国",
    "country": "ghana",
    "cc": "gh",
    "lat": 7.946527,
    "lon": -1.023194,
    "td_city_list": "アクラ"
  },
  "/9/sao-tome-and-principe/": {
    "country_ja": "サントメ・プリンシペ民主共和国",
    "country": "sao-tome-and-principe",
    "cc": "st",
    "lat": 0.18636,
    "lon": 6.613081,
    "td_city_list": "サントメ"
  },
  "/9/zambia/": {
    "country_ja": "ザンビア共和国",
    "country": "zambia",
    "cc": "zm",
    "lat": -13.133897,
    "lon": 27.849332,
    "td_city_list": "ルサカ"
  },
  "/9/sierra-leone/": {
    "country_ja": "シエラレオネ共和国",
    "country": "sierra-leone",
    "cc": "sl",
    "lat": 8.460555,
    "lon": -11.779889,
    "td_city_list": "フリータウン"
  },
  "/9/djibouti/": {
    "country_ja": "ジブチ共和国",
    "country": "djibouti",
    "cc": "dj",
    "lat": 11.825138,
    "lon": 42.590275,
    "td_city_list": "ジブチ"
  },
  "/9/comoros/": {
    "country_ja": "コモロ連合",
    "country": "comoros",
    "cc": "km",
    "lat": -11.6455,
    "lon": 43.3333,
    "td_city_list": "モロ二"
  },
  "/9/equatorial-guinea/": {
    "country_ja": "赤道ギニア共和国",
    "country": "equatorial-guinea",
    "cc": "gq",
    "lat": 1.650801,
    "lon": 10.267895,
    "td_city_list": "マラボ"
  },
  "/9/somalia/": {
    "country_ja": "ソマリア連邦共和国",
    "country": "somalia",
    "cc": "so",
    "lat": 5.152149,
    "lon": 46.199616,
    "td_city_list": "モガディシュ"
  },
  "/9/nigeria/": {
    "country_ja": "ナイジェリア連邦共和国",
    "country": "nigeria",
    "cc": "ng",
    "lat": 9.081999,
    "lon": 8.675277,
    "td_city_list": "アブジャ"
  },
  "/9/burundi/": {
    "country_ja": "ブルンジ共和国",
    "country": "burundi",
    "cc": "bi",
    "lat": -3.373056,
    "lon": 29.918886,
    "td_city_list": "ギテガ"
  },
  "/9/malawi/": {
    "country_ja": "マラウイ共和国",
    "country": "malawi",
    "cc": "mw",
    "lat": -13.254308,
    "lon": 34.301525,
    "td_city_list": "リロングウェ"
  },
  "/9/mauritius/": {
    "country_ja": "モーリシャス共和国",
    "country": "mauritius",
    "cc": "mu",
    "lat": -20.348404,
    "lon": 57.552152,
    "td_city_list": "ポートルイス"
  },
  "/9/liberia/": {
    "country_ja": "リベリア共和国",
    "country": "liberia",
    "cc": "lr",
    "lat": 6.428055,
    "lon": -9.429499,
    "td_city_list": "モンロビア"
  },
  "/9/rwanda/": {
    "country_ja": "ルワンダ共和国",
    "country": "rwanda",
    "cc": "rw",
    "lat": -1.940278,
    "lon": 29.873888,
    "td_city_list": "キガリ"
  },
  "/9/lesotho/": {
    "country_ja": "レソト王国",
    "country": "lesotho",
    "cc": "ls",
    "lat": -29.609988,
    "lon": 28.233608,
    "td_city_list": "マセル"
  }
}
